<div class="about">
    <div class="sign">
        <img src="/scenic.png" width="60%" alt="scenic route road sign" />
    </div>
    <div class="text">
        <p><b>America</b></p>
        <p>
            The gateway to all the natural wonders of the United States: both
            monumental and mundane. A&nbsp;serendipitous journey unfolding
            at&nbsp;your own pace.
        </p>
        <p>
            To report bugs or bad drivers:
            <a href="mailto:beep@4m3ric4.com">beep@4m3ric4.com</a>
        </p>
    </div>
</div>

<style>
    .about {
        display: flex;
        align-items: center;
        box-sizing: border-box;
        padding: var(--spacing);
        height: 95%;
    }

    .sign {
        display: flex;
        justify-content: center;
        min-width: 40%;
    }

    @media only screen and (max-width: 734px) {
        .sign {
            min-width: 60px;
        }

        .sign img {
            width: 80%;
        }
    }

    .text {
        display: flex;
        flex-grow: 1;
        flex-direction: column;
        padding-right: 20px;
    }

    @media only screen and (max-width: 734px) {
        .text {
            padding: 0 10px;
        }
    }

    p {
        hyphens: auto;
    }

    a {
        color: var(--title-hsl);
    }
</style>
